import barba from '@barba/core';
import MicroModal from 'micromodal';

export default class{
	constructor(){
        barba.hooks.afterOnce((data) => {
            this.init()
        });
        barba.hooks.after((data) => {
            this.init()
        });
        barba.hooks.afterLeave((data) => {
            this.init()
        });
    }
	// constructor() {
    //     barba.hooks.afterOnce((data) => {
    //         this.init();
    //     });
    //     barba.hooks.after((data) => {
    //         this.init();
    //     });
    // }
    init() {
		// MicroModal.init({
		// 	disableScroll: true,
		// 	awaitOpenAnimation: true,
		// 	awaitCloseAnimation: true
		// });
		MicroModal.init({
            awaitCloseAnimation: true,
            awaitOpenAnimation: true,
            disableScroll: true
        });
	}
}